import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { NewDownloadIconActive, WhiteCloseIcon } from "../../../assets/images";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type AppProps = {
  pathname?: undefined | string;
  success: number | null;
  error?: string;
  onClose?: () => void;
  title?: string;
  manager?: any;
  body?: any;
  disabled?: any;
  saveBtn?: string;
  onSubmit: () => void;
  downloadBtn?: { url: string; name: string } | null;
  loading?: boolean;
  closeAfterLoading?: string;
  showSchedulingEstimateData?: any;
  option1Btn?: string;
  option2Btn?: string;
  option1BtnFn?: () => void;
  option2BtnFn?: () => void;
  optionBtn1State?: boolean;
  optionBtn2State?: boolean;
};

export default function FullScreenDialog({
  pathname,
  error,
  success,
  downloadBtn,
  onClose,
  title,
  body,
  disabled,
  saveBtn,
  loading,
  onSubmit,
  closeAfterLoading,
  manager,
  showSchedulingEstimateData,
  option1Btn, //multiple button on header
  option2Btn,
  option1BtnFn,
  option2BtnFn,
  optionBtn1State,
  optionBtn2State,
}: AppProps) {
  const [open, setOpen] = React.useState(false);
  const [isSending, setIsSending] = React.useState(false);
  const dialogContentRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    setOpen(true);
  }, []);

  React.useEffect(() => {
    if (!pathname && success === 0 && !error?.length) {
      setOpen(false);
    }
  }, [success, error, pathname]);

  React.useEffect(() => {
    if (!pathname && isSending && !loading && !error?.length) {
      onClose && onClose();
      setOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, isSending, error, pathname]);

  const handleClose = () => {
    if (isSending && !error) {
      if (!closeAfterLoading?.length && !loading) {
        onClose && onClose();
        setOpen(false);
      }
    } else {
      onClose && onClose();
      setOpen(false);
    }
  };

  const handleSubmitData = () => {
    closeAfterLoading?.length && setIsSending(!isSending);
    onSubmit && onSubmit();
    if (!closeAfterLoading?.length) {
      onClose && onClose();
      setOpen(false);
    }
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar
          sx={{
            position: "relative",
            backgroundColor: "#d8dee4",
            boxShadow: "none",
          }}
        >
          <Toolbar>
            {!!closeAfterLoading?.length && isSending && loading ? null : (
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <img src={WhiteCloseIcon} alt="close" />
              </IconButton>
            )}
            <Typography
              sx={{ ml: 2, flex: 1, color: "#262a44" }}
              variant="h6"
              component="div"
            >
              {title}
            </Typography>
            {downloadBtn?.url ? (
              <a
                className={`btn ${
                  downloadBtn?.name ? "btn-primary" : ""
                }  mr-2`}
                style={{ color: "#FFFFFF", textTransform: "capitalize" }}
                href={downloadBtn?.url}
              >
                {downloadBtn?.name?.length ? (
                  downloadBtn?.name
                ) : (
                  <button
                    className="btn form-control d-flex"
                    style={{ border: "1px solid #dd4433", height: "34px" }}
                  >
                    <img src={NewDownloadIconActive} alt="" />
                  </button>
                )}
              </a>
            ) : null}
            {option1Btn ? (
              <button
                disabled={optionBtn1State}
                onClick={option1BtnFn}
                className="btn btn-primary mr-2"
              >
                {option1Btn}
              </button>
            ) : (
              ""
            )}
            {option2Btn ? (
              <button
                disabled={optionBtn2State}
                onClick={option2BtnFn}
                className="btn btn-primary mr-2"
              >
                {option2Btn}
              </button>
            ) : (
              ""
            )}
            {saveBtn ? (
              <Button
                autoFocus
                className="btn btn-primary"
                style={{ color: "#FFFFFF", textTransform: "capitalize" }}
                disabled={disabled}
                onClick={() => {
                  if (saveBtn === "Fill Transportation Deatils") {
                    if (dialogContentRef?.current) {
                      dialogContentRef?.current?.scrollTo({
                        top: dialogContentRef?.current?.scrollHeight,
                        behavior: "smooth",
                      });
                    }
                  } else {
                    handleSubmitData();
                    localStorage.setItem(
                      "leaveApproveBy",
                      String(
                        saveBtn === "Send for Approval"
                          ? manager?.value
                          : showSchedulingEstimateData?.created_by?.user_id
                      )
                    );
                  }
                }}
              >
                {!!closeAfterLoading?.length && isSending && loading
                  ? closeAfterLoading
                  : saveBtn}
              </Button>
            ) : null}
          </Toolbar>
        </AppBar>
        <div
          ref={dialogContentRef}
          style={{ maxHeight: "100vh", overflowY: "auto" }}
        >
          {body()}
        </div>
      </Dialog>
    </div>
  );
}
